import { motion } from "framer-motion";
import { Lock, Database } from "lucide-react";
import { PageHeader } from "@/components/Common";

export default function ComingSoon({ title, description, dataPoints = [] }) {
  return (
    <div>
      <PageHeader title={title} subtitle="Analisi avanzata — in arrivo" />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="dlx-card dlx-grain flex flex-col items-center justify-center p-12 text-center">
        <div className="relative mb-6">
          <div className="absolute inset-0 rounded-full blur-2xl" style={{ background: "rgba(212,175,55,0.2)" }} />
          <div className="relative flex h-16 w-16 items-center justify-center rounded-full border border-gold/30 bg-[#141418]">
            <Lock size={22} className="text-gold" />
          </div>
        </div>
        <h2 className="font-serif text-2xl text-white">{title}</h2>
        <p className="mt-2 max-w-lg font-sans text-sm text-zinc-500">{description}</p>

        <div className="mt-8 flex items-center gap-2 rounded-full border border-profit/25 bg-profit/5 px-4 py-2">
          <Database size={13} className="text-profit" />
          <span className="font-mono text-[11px] tracking-wider text-profit">
            Dati già raccolti e pronti per l'analisi
          </span>
        </div>

        {dataPoints.length > 0 && (
          <div className="mt-6 flex max-w-lg flex-wrap justify-center gap-2">
            {dataPoints.map((d) => (
              <span key={d} className="rounded-full border border-white/10 bg-white/[0.02] px-3 py-1 font-sans text-[11px] text-zinc-400">
                {d}
              </span>
            ))}
          </div>
        )}
      </motion.div>
    </div>
  );
}
